import { jsx as _jsx } from "react/jsx-runtime";
import { Button as FluentButton, makeStyles, Spinner } from "@fluentui/react-components";
import { forwardRef, useCallback, useContext, useState } from "react";
import { ToolContext } from "../hoc/fluentToolWrapper";
import { TokenMap } from "./utils";
import { Tooltip } from "./tooltip";
const useButtonStyles = makeStyles({
    smallIcon: {
        fontSize: TokenMap.px16,
    },
    mediumIcon: {
        fontSize: TokenMap.px20,
    },
});
export const Button = forwardRef((props, ref) => {
    const { size } = useContext(ToolContext);
    const classes = useButtonStyles();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { icon: Icon, label, onClick, disabled, className, title, ariaLabel, ...buttonProps } = props;
    const [isOnClickBusy, setIsOnClickBusy] = useState(false);
    const handleOnClick = useCallback(async (e) => {
        const result = onClick?.(e);
        if (result instanceof Promise) {
            setIsOnClickBusy(true);
            try {
                await result;
            }
            finally {
                setIsOnClickBusy(false);
            }
        }
    }, [onClick]);
    const iconClass = size === "small" ? classes.smallIcon : classes.mediumIcon;
    return (_jsx(Tooltip, { content: title ?? "", children: _jsx(FluentButton, { ref: ref, iconPosition: "after", ...buttonProps, className: className, size: size, "aria-label": ariaLabel ?? (!label ? title : undefined), icon: isOnClickBusy ? _jsx(Spinner, { size: "extra-tiny" }) : Icon && _jsx(Icon, { className: iconClass }), onClick: handleOnClick, disabled: disabled || isOnClickBusy, children: label && props.label }) }));
});
Button.displayName = "Button";
//# sourceMappingURL=button.js.map